const GA_ID = 'G-F5W56J9BV1';

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    send_to: GA_ID,
  });
}

export function trackEvent(eventName, params) {
  gtag('event', eventName, {
    ...params,
    send_to: GA_ID,
  });
}

export function trackGalleryOpen(albumName) {
  trackEvent('view_gallery', {
    event_category: 'gallery',
    event_label: albumName,
  });
}

export function trackPhotoView(albumName, photoName) {
  trackEvent('view_photo', {
    event_category: 'gallery',
    event_label: `${albumName} - ${photoName}`,
  });
}

export function trackMenuClick(menuItem) {
  trackEvent('menu_click', {
    event_category: 'navigation',
    event_label: menuItem,
  });
}

export function trackOutboundLink(url) {
  trackEvent('click', {
    event_category: 'outbound',
    event_label: url,
    transport_type: 'beacon',
  });
}

export function trackScrollDepth(percent) {
  trackEvent('scroll_depth', {
    event_category: 'engagement',
    event_label: `${percent}%`,
    value: percent,
  });
}

export function trackLanguageChange(language) {
  trackEvent('language_change', {
    event_category: 'engagement',
    event_label: language,
  });
}

// Scroll depth tracking - fires at 25%, 50%, 75%, 100%
let scrollMilestones = new Set();

export function initScrollTracking() {
  scrollMilestones = new Set();
  window.addEventListener('scroll', handleScroll);
}

export function cleanupScrollTracking() {
  window.removeEventListener('scroll', handleScroll);
}

function handleScroll() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  if (docHeight <= 0) return;
  const percent = Math.round((scrollTop / docHeight) * 100);

  [25, 50, 75, 100].forEach((milestone) => {
    if (percent >= milestone && !scrollMilestones.has(milestone)) {
      scrollMilestones.add(milestone);
      trackScrollDepth(milestone);
    }
  });
}

// Outbound link tracking - auto-attach to document
export function initOutboundLinkTracking() {
  document.addEventListener('click', handleOutboundClick);
}

function handleOutboundClick(e) {
  const link = e.target.closest('a[href]');
  if (!link) return;
  const href = link.getAttribute('href');
  if (href && href.startsWith('http') && !href.includes(window.location.hostname)) {
    trackOutboundLink(href);
  }
}
